import { useMutation, useQueryClient } from "@tanstack/react-query";
import updatePhaseRule from "api/campaign/updatePhaseRule";
import handleInvalidateError from "helpers/handleInvalidateError";
import { phaseIdKey } from "queryKeys/phase";
import { phaseRulesWithCampaignId } from "queryKeys/phaseRulesKey";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function useUpdatePhaseRuleMutation() {
  const queryClient = useQueryClient();
  const { id: campaignId } = useParams();
  return useMutation({
    mutationFn: updatePhaseRule,
    onSuccess: (data) => {
      toast.success(data?.message || "Rule updated successfully");

      queryClient
        .invalidateQueries({ queryKey: phaseRulesWithCampaignId({ campaignId }) })
        .catch(handleInvalidateError);

      queryClient
        .invalidateQueries({ queryKey: phaseIdKey(campaignId) })
        .catch(handleInvalidateError);
    },
  });
}
